require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./videos-bangkok-traffic.json") })
        }
      }, "path---videos-bangkok-traffic");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---videos-bangkok-traffic!./.cache/json/videos-bangkok-traffic.json
// module id = 944
// module chunks = 231608221292675